import { t } from "ttag";

import {
  getPaymentStatusLabel,
  PAYMENT_STATUS_COLOR,
} from "@/features/billing/models";
import { PaymentMethodDisplay } from "@/features/payments/components";
import type { Invoice } from "@/shared/domains";
import {
  Badge,
  DownloadMinimalisticIcon,
  EmptyState,
  Table,
} from "@/shared/ui";
import { formatISO } from "@/shared/utils";

interface PaymentHistoryTableProps {
  payments: Invoice[];
}

export const PaymentHistoryTable = ({ payments }: PaymentHistoryTableProps) => {
  return (
    <Table.Root className="table-fixed">
      <Table.Header>
        <Table.Row>
          <Table.Head className="w-24">{t`Date`}</Table.Head>
          <Table.Head className="w-1/3">{t`Detail`}</Table.Head>
          <Table.Head className="w-24">{t`Plan`}</Table.Head>
          <Table.Head className="w-24">{t`Amount`}</Table.Head>
          <Table.Head className="w-24">{t`Payment`}</Table.Head>
          <Table.Head className="w-28 text-center">{t`Status`}</Table.Head>
          <Table.Head className="w-20 text-center">{t`Invoice`}</Table.Head>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {payments.length ? (
          payments.map((payment) => (
            <Table.Row key={`payment-${payment.id}`}>
              <Table.Cell>{formatISO(payment.date)}</Table.Cell>
              <Table.Cell className="truncate" title={payment.detail}>
                {payment.detail}
              </Table.Cell>
              <Table.Cell
                className="truncate"
                title={payment.productCategory?.name}
              >
                {payment.productCategory?.name ?? "-"}
              </Table.Cell>
              <Table.Cell>${payment.amount}</Table.Cell>
              <Table.Cell>
                <PaymentMethodDisplay
                  paymentMethod={payment.paymentMethod}
                  compact
                />
              </Table.Cell>
              <Table.Cell className="flex items-center justify-center">
                <Badge
                  color={PAYMENT_STATUS_COLOR[payment.status]}
                  size="x-small"
                  className="min-w-24"
                >
                  {getPaymentStatusLabel(payment.status)}
                </Badge>
              </Table.Cell>

              <Table.Cell>
                <div className="flex justify-center">
                  {payment.hostedInvoiceUrl ? (
                    <DownloadMinimalisticIcon
                      className="size-6 cursor-pointer"
                      onClick={() =>
                        window.open(payment.hostedInvoiceUrl ?? "")
                      }
                    />
                  ) : (
                    "-"
                  )}
                </div>
              </Table.Cell>
            </Table.Row>
          ))
        ) : (
          <Table.Row>
            <Table.Cell colSpan={7}>
              <EmptyState.Root className="border-none">
                <EmptyState.Icon />
                <EmptyState.Description>
                  {t`You haven't had any payment yet`}
                </EmptyState.Description>
              </EmptyState.Root>
            </Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table.Root>
  );
};
